var _defs, _rect, _g, _ellipse, _g2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKasifpl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 500,
    viewBox: "0 0 1200 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "background",
    x1: 70,
    y1: 34,
    x2: 1118,
    y2: 466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#102A4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent",
    x1: 366,
    y1: 137,
    x2: 796,
    y2: 365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A5CFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: 272,
    y: 61,
    width: 656,
    height: 378,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 500,
    rx: 28,
    fill: "url(#background)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    stroke: "#70DFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 114H1200M0 386H1200M236 0V500M964 0V500"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 250,
    r: 122
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0V500"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 143,
    width: 154,
    height: 214
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1046,
    y: 143,
    width: 154,
    height: 214
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 250,
    rx: 280,
    ry: 135,
    fill: "#52C8FF",
    fillOpacity: 0.16,
    filter: "url(#glow)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(505 69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 0L177 34V112C177 180 143 229 95 258C47 229 13 180 13 112V34L95 0Z",
    fill: "url(#accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 22L156 47V110C156 160 132 198 95 224C58 198 34 160 34 110V47L95 22Z",
    fill: "#08172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 54V192M59 92H131M56 151H134",
    stroke: "#EAF8FF",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 122,
    r: 24,
    fill: "#08172B",
    stroke: "#EAF8FF",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 68L95 53L126 68",
    stroke: "#EAF8FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 376,
    fill: "#F5FBFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 78,
    fontWeight: 800,
    textAnchor: "middle",
    letterSpacing: 5
  }, "KASI", /*#__PURE__*/React.createElement("tspan", {
    fill: "#59D4FF"
  }, "FPL"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 423,
    fill: "#B9CDE2",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    textAnchor: "middle",
    letterSpacing: 7
  }, "FANTASY INTELLIGENCE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKasifpl);
export default __webpack_public_path__ + "static/media/kasifpl.179e677c776fad872993b203c48d93f4.svg";
export { ForwardRef as ReactComponent };